// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { SALES_AND_MARKETING_REDUCER_KEY } from "..";
import { getPeriodValue } from "./helpers";
import {
  hp_fp_foundersAndPartnersHeaderMonth,
  hp_sm_businessDevelopmentMonths,
  hp_sm_costPerHeadMonth,
  hp_sm_crmMonths,
  hp_sm_marketingTeamMonth,
  hp_sm_salesTeamKeyMonth,
  hp_sm_socialMediaAndContentDesignMonth,
  hp_sm_subscriberSupportMonths,
  hp_sm_userAcquisitionMonth,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

const prefix = "hp_sm_";

export const SALES_AND_MARKETING_HEADER_KEY =
  prefix + "salesAndMarketingHeader";
export const HEAD_COUNT_KEY = prefix + "headCount";
export const SALES_TEAM_KEY = prefix + "salesTeamKey";
export const MARKETING_TEAM_KEY = prefix + "marketingTeam";
export const BUSINESS_DEVELOPMENT_KEY = prefix + "businessDevelopment";
export const USER_ACQUISITION_KEY = prefix + "userAcquisition";
export const CRM_KEY = prefix + "crm";
export const SUBSCRIBER_SUPPORT_KEY = prefix + "subscriberSupport";
export const SOCIAL_MEDIA_CONTENT_DESIGN_TEAM_KEY =
  prefix + "socialMediaAndContentDesign";
export const COMMUNITY_MANAGEMENT_KEY = prefix + "communityManagement";
export const COST_PER_HEAD_KEY = prefix + "costPerHead";

export const hpSalesAndMarketingItems = [
  SALES_AND_MARKETING_HEADER_KEY,
  HEAD_COUNT_KEY,
  SALES_TEAM_KEY,
  MARKETING_TEAM_KEY,
  BUSINESS_DEVELOPMENT_KEY,
  USER_ACQUISITION_KEY,
  CRM_KEY,
  SUBSCRIBER_SUPPORT_KEY,
  SOCIAL_MEDIA_CONTENT_DESIGN_TEAM_KEY,
  COMMUNITY_MANAGEMENT_KEY,
  COST_PER_HEAD_KEY,
];

export const initialState = {
  [SALES_AND_MARKETING_HEADER_KEY]: {
    title: "Sales & Marketing & Subscriber Success Team",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const headCount = Number(
        getReducerFunc(SALES_AND_MARKETING_REDUCER_KEY)[
          HEAD_COUNT_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
      const costPerHead = getPeriodValue(
        getReducerFunc(SALES_AND_MARKETING_REDUCER_KEY)[COST_PER_HEAD_KEY],
        yearKey,
        getReducerFunc
      );

      return headCount * costPerHead;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [HEAD_COUNT_KEY]: {
    title: "Head Count",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      let result = 0;
      for (let i = 2; i < hpSalesAndMarketingItems.length - 1; i++) {
        result += getPeriodValue(
          getReducerFunc(SALES_AND_MARKETING_REDUCER_KEY)[
            hpSalesAndMarketingItems[i]
          ],
          yearKey,
          getReducerFunc
        );
      }
      return result;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [SALES_TEAM_KEY]: {
    title: "Sales Team",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_salesTeamKeyMonth,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 2,
      [years.YEAR_5_KEY]: 2,
    },
  },
  [MARKETING_TEAM_KEY]: {
    title: "Marketing Team",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_marketingTeamMonth,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 2,
    },
  },
  [BUSINESS_DEVELOPMENT_KEY]: {
    title: "Business Development",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_businessDevelopmentMonths,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [USER_ACQUISITION_KEY]: {
    title: "User Acquisition",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_userAcquisitionMonth,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 2,
      [years.YEAR_5_KEY]: 2,
    },
  },
  [CRM_KEY]: {
    title: "CRM",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_crmMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [SUBSCRIBER_SUPPORT_KEY]: {
    title: "Subscriber Support",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_subscriberSupportMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [SOCIAL_MEDIA_CONTENT_DESIGN_TEAM_KEY]: {
    title: "Social Media & Content Design Team",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_socialMediaAndContentDesignMonth,
    years: {
      [years.YEAR_1_KEY]: 2,
      [years.YEAR_2_KEY]: 2,
      [years.YEAR_3_KEY]: 2,
      [years.YEAR_4_KEY]: 2,
      [years.YEAR_5_KEY]: 2,
    },
  },
  [COMMUNITY_MANAGEMENT_KEY]: {
    title: "Community Management",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_businessDevelopmentMonths,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [COST_PER_HEAD_KEY]: {
    title: "Cost per Head",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_costPerHeadMonth,
    years: {
      [years.YEAR_1_KEY]: 2500,
      [years.YEAR_2_KEY]: 2500,
      [years.YEAR_3_KEY]: 2500,
      [years.YEAR_4_KEY]: 2500,
      [years.YEAR_5_KEY]: 2500,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const hpSalesAndMarketingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SALES_MARKETING_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_SALES_MARKETING_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_SALES_MARKETING_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_SALES_MARKETING_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default hpSalesAndMarketingReducer;
